import { render } from "./ImagePop.vue?vue&type=template&id=9459957c"
import script from "./ImagePop.vue?vue&type=script&lang=js"
export * from "./ImagePop.vue?vue&type=script&lang=js"

import exportComponent from "D:\\inspemblelcsgn\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__